import React from 'react';
import styled from 'styled-components';

const AccMap = styled.div<{
  color?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  img {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    user-select: none;
  }
`;

type Props = { data };
function Acc({ data }: Props) {
  if (!data) return null;

  return (
    <AccMap className="body">
      <img className="right-acc" src={data.rightAcc} alt="" />
      <img className="left-acc" src={data.leftAcc} alt="" />
    </AccMap>
  );
}

export default Acc;
